import { FileToUpload } from "./filetoupload";

export class OnboardHREmpDoc {
  ID: number;
  EmpId: number;
  HRDocTypeId: number;
  DocNumber: string;
  DocumentName: string;
  DocumentPath: string;
  DocTypeName: string;
  File: FileToUpload;
  EducationDetailsID: number;
  PreviousEmploymentDetailsID: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}
